
import { ICouponReceiveDiscountSetting, ICouponReferralSetting } from 'features/coupon/types';
import { first } from 'lodash';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import { IResponseDataBody } from 'services/response';
import actions from './actions';
import apis from './apis';

const getCouponReceiveDiscountSetting: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const res: IResponseDataBody<ICouponReceiveDiscountSetting[]> = yield call(apis.getCouponListByType, payload, 'NEW_CUSTOMER');
    const data = first(res.data.data);
    if (data) {
      yield put(actions.getCouponReceiveDiscountSetting.success(data));
    }
  } catch (error) { } finally {
  }
};

const getBirthdayDiscount: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const res: IResponseDataBody<ICouponReceiveDiscountSetting[]> = yield call(apis.getCouponListByType, payload, 'BIRTHDAY');
    const data = first(res.data.data);
    if (data) {
      yield put(actions.getBirthdayDiscount.success(data));
    }
  } catch (error) { } finally {
  }
};

const getReferralDiscountExitsCustomer: ISagaFunc<string> = function* ({ payload }) {
  yield delay(200);
  try {
    const res: IResponseDataBody<ICouponReferralSetting> = yield call(apis.getReferralDiscountExitsCustomer, payload);
    if (res.data.data) {
      yield put(actions.getReferralDiscountExitsCustomer.success(res.data.data));
    }
  } catch (error) { } finally { }
};

export default function* couponServiceSagas() {
  yield takeLatest(actions.getCouponReceiveDiscountSetting.fetch, getCouponReceiveDiscountSetting);
  yield takeLatest(actions.getBirthdayDiscount.fetch, getBirthdayDiscount);
  yield takeLatest(actions.getReferralDiscountExitsCustomer.fetch, getReferralDiscountExitsCustomer);
}
